import React from 'react';
import styles from 'components/overlays/helpTooltip/HelpTooltip.module.css';
import clsx from 'clsx';
import CustomTooltip, { iconTypes } from 'components/overlays/CustomTooltip';

type HelpTooltipProps = {
  /**
   * ID for elevio, which wires onClick event based on this value and opens help.
   */
  id: string;

  /**
   * Title to show on hover.
   */
  title?: string;

  /**
   * Text for custom tooltip.
   */
  text?: string;

  /**
   * ClassName overrides.
   */
  className?: string;

  /**
   * Size of the icon in pixels, this value overrides provided inline styles.
   */
  fontSize?: number;

  /**
   * Inline style overrides for wrapping span.
   */
  style?: any;
};

/**
 * Elevio questionMark help icon.
 */
export const HelpTooltip: React.FC<HelpTooltipProps> = ({
  id,
  text = 'Show help',
  className,
  fontSize,
  title,
  style,
}: HelpTooltipProps) => {
  // We let user to define custom styles, if he also includes size of the icon it overrides the inline style settings
  const fontSizeOverride = fontSize ? fontSize : 'auto';
  const inlineStyle = style ? { ...style, fontSize: fontSizeOverride } : { fontSize: fontSize };

  return (
    <span title={title ? title : undefined} className={clsx(styles.helpToolTip, className)} style={inlineStyle}>
      <CustomTooltip id={id} iconClassName={`js-${id} btn-link`} text={text} iconType={iconTypes.HELP} />
    </span>
  );
};

export default HelpTooltip;
